// extracted by mini-css-extract-plugin
module.exports = {"Workplace":"App_Workplace__2q9Fh","White":"App_White__NXTmh","Black":"App_Black__16uLi","Blue":"App_Blue__nNMR2"};